import { useEffect, useState } from "react";
import { Breadcrumbs, Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { usePriceListProductStore } from "../../hooks/usePriceListProductStore";
import { usePriceListCustomerStore } from "../../hooks/usePriceListCustomerStore";
import { ModalAddCustomer } from "./ModalAddCustomer/ModalAddCustomer";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'codesystem_product', label: 'Código', align: 'center' },
    { type: 'text', field: 'name_product', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'price', label: 'Precio', align: 'center' },
];

const columnscustomer = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut_customer', label: 'Rut', align: 'center' },
    { type: 'text', field: 'name_customer', label: 'Cliente', align: 'center' },
    { type: 'text', field: 'email_customer', label: 'Correo', align: 'center' },
    { type: 'text', field: 'phone_customer', label: 'Teléfono', align: 'center' },
];

export const DetailListProducts: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, setView, setAddProduct, listSelected, clearState } = props;

    const { setActionPriceListProduct, getPriceListProduct, deleteDetail, priceListProduct } = usePriceListProductStore();
    const { getPriceListCustomers, createPriceListCustomer, deletePriceListCustomer } = usePriceListCustomerStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalConfirm2, setShowModalConfirm2] = useState<boolean>(false);
    const [showListProducts, setShowListProducts] = useState<boolean>(false);
    const [customers, setCustomers] = useState<any>([]);
    const [showAddCustomer, setShowAddCustomer] = useState<boolean>(false)

    useEffect(() => {
        getPriceListProductApi()
        getPriceListCustomersApi()
    }, [])

    const getPriceListProductApi = async (search = '') => {
        try {
            setLoading(true);
            await getPriceListProduct({ search: search, idpricelist: listSelected.id });
            setLoading(false);

        } catch (error) {
            setLoading(false);
        }
    }

    const getPriceListCustomersApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getPriceListCustomers({ search: search, idpricelist: listSelected.id });
            if (!response) {
                setCustomers([]);
                setLoading(false);
                return false;
            } else {
                setCustomers(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setAddProduct(true);
        setView('addProduct');
    }

    const onEdit = (rowSelected: any) => {
        setActionPriceListProduct('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDelete = (rowSelected: any) => {
        setActionPriceListProduct('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }

    const onDetails = () => {
        setAddProduct(true);
        setView('addProduct');
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteDetail(rowSelected.id)
            if (response) {
                getPriceListProductApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const handleAddCustomer = (): void => {
        setShowAddCustomer(true)
    }

    const onDeleteCustomer = (rowSelected: any): void => {
        setRowSelected(rowSelected);
        setShowModalConfirm2(true);
    }

    const onDeleteConfirm2 = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deletePriceListCustomer(rowSelected.id)
            if (response) {
                getPriceListCustomersApi();
                setShowModalConfirm2(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <>
            <CustomForm >
                <CustomFormHeader
                    title={'Lista de productos agregados'}
                    onCancel={closeModal}
                    clearState={clearState}
                >
                </CustomFormHeader>
                <CustomFormBody>
                    <Grid container sx={{ padding: '3px 20px 20px 20px' }}>
                        <CustomTable
                            disabled_title
                            columns={columns}
                            loading={loading}
                            rows={priceListProduct || []}
                            onRowClick={() => { }}
                            hasOptions
                            onAddFn={onAdd}
                            onAddFnName={'Agregar'}
                            // onDetails={onDetails}
                            onDelete={onDelete}
                            onSearch
                            dense
                        />
                    </Grid>

                </CustomFormBody>

                <CustomFormHeader
                    title={'Lista de clientes asignados'}
                    onCancel={closeModal}
                    clearState={clearState}
                >
                </CustomFormHeader>
                <CustomFormBody>
                    <Grid container sx={{ padding: '3px 20px 20px 20px' }}>
                        <CustomTable
                            disabled_title
                            columns={columnscustomer}
                            loading={loading}
                            rows={customers || []}
                            onRowClick={() => { }}
                            hasOptions
                            onAddFn={handleAddCustomer}
                            onAddFnName={'Agregar'}
                            onDelete={onDeleteCustomer}
                            onSearch
                            dense
                        />
                    </Grid>

                </CustomFormBody>
            </CustomForm>
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
            {showModalConfirm2 && (
                <ModalConfirm
                    open={showModalConfirm2}
                    closeModal={() => { setShowModalConfirm2(false); clearState() }}
                    onConfirm={onDeleteConfirm2}
                    status={loading}
                />
            )}
            {showAddCustomer && (
                <ModalAddCustomer
                    open={showAddCustomer}
                    onClose={() => setShowAddCustomer(false)}
                    onList={getPriceListCustomersApi}
                    priceList={listSelected}
                />
            )}
        </>
    )
}